/**
 * Thẻ trạng thái khách (customer_tags) có trường `page` cho biết sau khi chuyển trạng thái
 * thì lịch hẹn thuộc về màn hình nào:
 *   1 = chi tiết lịch hẹn, 2 = chi tiết lịch tư vấn, 3 = chi tiết lịch thực hiện.
 * `page` rỗng (null) nghĩa là không đổi màn hình.
 */
export const APPOINTMENT_PAGE = {
    APPOINTMENT: 1,
    CONSULTATION: 2,
    EXECUTION: 3,
} as const;

const PATH_BY_PAGE: Record<number, string> = {
    1: "/appointment/detail",
    2: "/consultation/detail",
    3: "/execution-schedule/detail",
};

/** Đường dẫn chi tiết tương ứng với `page`; trả null nếu page không hợp lệ */
export const getAppointmentDetailPath = (
    page: any,
    id: number | string
): string | null => {
    const base = PATH_BY_PAGE[Number(page)];
    return base ? `${base}/${id}` : null;
};
